import { forumMutation } from '@/helpers/graphql_modules/forum';
import {
  createDiscussion,
  deleteDiscussion,
  updateDiscussion,
} from '@/store/mutations/forumMutations';
import { FileModel } from '@/models/FileModel';

type CreateDiscussionPayload = {
  name: string;
  text: string;
  userId: number;
  channelId: number;
  attachments: FileModel[];
};

type UpdateDiscussionPayload = {
  text: string;
  discussionId: number;
  attachments: FileModel[];
};

export class DiscussionService {
  public static async createDiscussion(
    payload: CreateDiscussionPayload,
  ): Promise<Record<string, any>> {
    const { name, text, userId, channelId, attachments } = payload;

    return forumMutation(createDiscussion, {
      name,
      text,
      channelId,
      userId,
      attachments,
    });
  }

  public static async updateDiscussion(
    payload: UpdateDiscussionPayload,
  ): Promise<Record<string, any>> {
    const { discussionId, text, attachments } = payload;

    return forumMutation(updateDiscussion, {
      text,
      attachments,
      discussionId,
    });
  }

  public static async deleteDiscussion(discussionId: number): Promise<void> {
    await forumMutation(deleteDiscussion, {
      discussionId,
    });
  }
}
